import adminAPI from "../../api/apiAdmin";

class AdminCatalogService {
    /**
     * Fetches the current catalog metadata.
     * Returns null if no catalog is found.
     */
    static async get() {
        try {
            const res = await adminAPI.get("/admin/catalog");
            return res.data.data;
        } catch (err) {
            if (err?.response?.status === 404) return null;
            throw err;
        }
    }

    /**
     * Uploads or replaces the catalog PDF.
     * Since the backend handles deletion of old files, we just send the new one.
     */
    static async upload(file) {
        const formData = new FormData();
        formData.append("file", file);

        const res = await adminAPI.post("/admin/catalog", formData);
        return res.data.data;
    }

    /**
     * Deletes the catalog record and file.
     */
    static async delete() {
        const res = await adminAPI.delete("/admin/catalog");
        return res.data;
    }
}

export default AdminCatalogService;
